import HT from 'handsontable';
import { BaseValidator } from 'handsontable/validators';
import { numericValidator, dateValidator } from '../validators';

export const columnTypeToHTValidatorMap: Partial<Record<HT.CellType, BaseValidator>> = {
  dropdown: HT.validators.AutocompleteValidator,
  numeric: numericValidator,
  date: dateValidator,
};
